import { createContext } from "react"; 

export const MainRfContext = createContext(null);